import { render } from "./PatientInformations.vue?vue&type=template&id=2542af32"
import script from "./PatientInformations.vue?vue&type=script&lang=js"
export * from "./PatientInformations.vue?vue&type=script&lang=js"

import "./PatientInformations.vue?vue&type=style&index=0&id=2542af32&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/orders/PatientInformations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2542af32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2542af32', __exports__)) {
    console.log('reload')
    api.reload('2542af32', __exports__)
  }
  
  module.hot.accept("./PatientInformations.vue?vue&type=template&id=2542af32", () => {
    console.log('re-render')
    api.rerender('2542af32', render)
  })

}


export default __exports__